import React, { Fragment, Component } from 'react'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import Loader from '../Loader'
import Faq from './Faq'
import StatisticRate from '../StatisticRate'
import Services from '../Services'
import TextDescription from '../TextDescription'
import Slider from './Slider'

import './index.sass'
import '../Home/HomeNavigation/PointedSlider/index.sass'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'

class About extends Component {
  componentDidMount = () => {
    const {
      about,
      home,
      actions: { getAboutList, getHomeList },
    } = this.props

    if (Object.keys(about).length === 0) {
      getAboutList()
    }

    if (
      Object.keys(about).length === 0 ||
      Object.keys(home).length === 0 ||
      !(home.home && home.home.statistic)
    ) {
      getHomeList()
    }
  }
  render = () => {
    const { loading, about, home, t, lng } = this.props
    const isComponenReadyForRender =
      Object.keys(about).length &&
      (Object.keys(home).length > 0 && home.home && home.home.statistic)
    const translatedAdditionalVoices =
      !loading &&
      isComponenReadyForRender &&
      about.AdditionalTextAbout.voices.texts.map((_, ind) => t(`about.voices.${ind}`))
    const translatedAdditionalForeanLang =
      !loading &&
      isComponenReadyForRender &&
      about.AdditionalTextAbout.foreanLang.texts.map((_, ind) => t(`about.foreanLang.${ind}`))
    const translatedAdditionalExpirience =
      !loading &&
      isComponenReadyForRender &&
      about.AdditionalTextAbout.experience.texts.map((_, ind) => t(`about.experience.${ind}`))
    return (
      <Fragment>
        <Helmet>
          <html lang={lng} />
          <title>{t('meta.about.title')}</title>
          <link rel="alternate" hrefLang="en"
              href="https://unimedia.io/about" />
          <link rel="alternate" hrefLang="de"
              href="https://unimedia.io/de/about" />
          <link rel="alternate" hrefLang="ru"
              href="https://unimedia.io/ru/about" />
          <link rel="alternate" hrefLang="x-default"
              href="https://unimedia.io/about" />
          <meta name="description" content={t('meta.about.descr')} />
          {lng === 'en' && <meta name="keywords" content={t('meta.about.keywords')} />}
          {lng === 'en' ? <link rel="canonical" href={'https://unimedia.io/about'} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/about`} />}
          <meta property="og:title" content={t('meta.about.title')} />
          <meta property="og:description" content={t('meta.about.descr')} />
          <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
          <meta property="og:url" content={lng === 'en'? 'https://unimedia.io/about' : `https://unimedia.io/${lng}/about`} />
          <script type="application/ld+json">
            {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${t('productDescription')}",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t('meta.about.descr')}",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Universal Media",
                "alternateName": "Unimedia",
                "url": "https://unimedia.io",
                "logo": "https://unimedia.io/assets/logo.svg"
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.about')}"
              }]
            }]`}
          </script>
        </Helmet>
        <ScrollUpButton id={'about'} />
        <div className="about-page container overflow-y" id='about'>
          
          <div className="container-wrapper">
          <Breadcrumbs pathname={window.location.pathname}/>
            <h1 className="main-title">{t('about.title')}</h1>
            
            {loading ? (
              <Loader />
            ) : isComponenReadyForRender ? (
              <Fragment>
                <div className="about-page-grid">
                  <StatisticRate componentText={home.home.statistic} />

                  <div className="additional-info">
                    <TextDescription arrText={translatedAdditionalVoices} />
                    <div className="additional-info-img">
                      <img src="/assets/about-img1.webp" alt="img1" />
                    </div>
                  </div>

                  <div className="additional-info">
                    <TextDescription arrText={translatedAdditionalForeanLang} />
                    <div className="additional-info-img">
                      <img src="/assets/about-img2.webp" alt="img1" />
                    </div>
                  </div>

                  <div className="additional-info">
                    <TextDescription arrText={translatedAdditionalExpirience} />
                    <div className="additional-info-img">
                      <img src="/assets/about-img3.webp" alt="img1" />
                    </div>
                  </div>
                </div>
                <div className="placeholder-wave" />

                <Services services={about.services.services} />
                <div className="slider-team">
                  <h3>{t('about.ourTeam.title')}</h3>
                  <Slider slider={about.slider.slider} />
                </div>
                <div className="placeholder-img-about" />
                <h3>{t('about.faq.title')}</h3>
                <div className="faq">
                  {about.faq.faq.map(({ title, answer }, ind) => (
                    <Faq key={ind} ind={ind} title={title} answer={answer} />
                  ))}
                </div>
              </Fragment>
            ) : null}
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  about: state.about,
  home: state.home,
  loading: state.app.loading,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(About)
)
